import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { DeleteOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { discountOptions } from "../../../utils/discountOptions";

export const LicenseCodeColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  modifiedItems,
  modifiedTypes
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  return [
    {
      title: "Name",
      dataIndex: "CodeName",
      key: "CodeName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="CodeName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "CodeName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Item",
      dataIndex: "Item",
      key: "Item",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Item"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Item",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (_, item) => {
        const matchedItem = modifiedItems?.find(
          (modItem) => modItem.value === item?.Item
        );
        return matchedItem?.label || "";
      },
    },

    {
      title: "Code",
      dataIndex: "Code",
      key: "Code",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Code"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Code",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Annually",
      dataIndex: "Annually",
      key: "Annually",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Annually"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Annually",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (item) => {
        return typeof item === "string" ? "$ " + item : item;
      },
    },
    {
      title: "One Time",
      dataIndex: "OneTime",
      key: "OneTime",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OneTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OneTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (item) => {
        return typeof item === "string" ? "$ " + item : item;
      },
    },
    {
      title: "Surcharge",
      dataIndex: "Surcharge",
      key: "Surcharge",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Surcharge"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Surcharge",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (text) => {
        const matchedValue = discountOptions.find(
          (item) => item.value === text
        )?.label;
        return <>{matchedValue}</>;
      },
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-1 rounded-[4px] mr-1 ">
                  <Link
                    to={`/licensecode/edit/${record.CodeNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.CodeNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-1 rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
